import { render, staticRenderFns } from "./SparIndividual.vue?vue&type=template&id=686cf5ef&"
import script from "./SparIndividual.vue?vue&type=script&lang=ts&"
export * from "./SparIndividual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports